/**
 * Zone-based inventory gating
 * ----------------------------
 * Disables Add to Cart when the visitor's zone-specific fulfillment
 * center is out of stock, even if other locations (and therefore
 * Shopify's default `variant.available`) still show stock.
 *
 * Depends on the `.zone-inventory-status` block rendered by
 * snippets/zone-inventory-status.liquid, which carries
 * data-zone-qty for the CURRENTLY rendered variant.
 *
 * If the product has multiple variants, Dawn dispatches a
 * `variant:change` event on the product form when the shopper picks
 * a different variant. Listen for that and re-render the status
 * block's data via a small fetch to the product's JSON, since the
 * zone quantities differ per variant.
 *
 * Add this file as assets/zone-inventory.js and load it with:
 *   {{ 'zone-inventory.js' | asset_url | script_tag }}
 * near the bottom of sections/main-product.liquid.
 */
(function () {
  function applyGate(root) {
    var statusEl = root.querySelector('.zone-inventory-status');
    if (!statusEl) return;

    var qty = parseInt(statusEl.dataset.zoneQty, 10) || 0;
    var form = root.querySelector('form[action^="/cart/add"]');
    if (!form) return;

    var submitBtn = form.querySelector('[type="submit"]');
    if (!submitBtn) return;

    if (qty <= 0) {
      submitBtn.setAttribute('disabled', 'disabled');
      submitBtn.dataset.zoneGatedLabel = submitBtn.textContent;
      submitBtn.querySelector('span') && (submitBtn.querySelector('span').textContent = 'Out of Stock in Your Region');
    } else {
      // Only re-enable if nothing else (e.g. Dawn's own sold-out logic) had it disabled
      if (submitBtn.dataset.zoneGatedLabel) {
        submitBtn.removeAttribute('disabled');
        submitBtn.querySelector('span') && (submitBtn.querySelector('span').textContent = submitBtn.dataset.zoneGatedLabel);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-info, .product').forEach(applyGate);
  });

  // Dawn fires this custom event on variant swap; the status block's
  // data-zone-qty needs updating server-side per variant (see note
  // below) before this re-check is meaningful.
  document.addEventListener('variant:change', function (evt) {
    var root = evt.target.closest('product-info, .product') || document;
    applyGate(root);
  });
})();